import { Navigate, useLocation, useParams } from "react-router-dom";

/**
 * Legacy email links (/link/participant/redirect/:type) forward to /mobile/*
 * without participant web login. Old epro links have no slug → generic /mobile.
 */
const LegacyParticipantLinkRedirect = () => {
  const { type } = useParams();
  const location = useLocation();

  if (type === "consent") {
    return (
      <Navigate to={`/mobile/consent${location.search}`} replace />
    );
  }

  if (type === "epro") {
    return <Navigate to="/mobile" replace />;
  }

  return <Navigate to="/mobile" replace />;
};

export default LegacyParticipantLinkRedirect;
